var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "login-token-container" }, [
      _c("div", { staticClass: "loading-wrapper" }, [
        _c("div", { staticClass: "loading-spinner" }),
        _c("div", { staticClass: "loading-text" }, [_vm._v("正在登录中...")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }